<template>
  <b-table-simple bordered
                  id="tendency-comparison-table">
    <b-thead head-variant="light">
      <tr>
        <template v-for="col in cols">
          <b-th :key="col"
                v-if="col === '구분'"
                colspan="2">{{ col }}
          </b-th>
          <b-th :key="col"
                v-else-if="col !== '차수'">{{ col }}
          </b-th>
        </template>
      </tr>
    </b-thead>
    <b-tbody>
      <template v-for="(row, i) in items">
        <b-tr :key="`row${i}`">
          <template v-for="(col, j) in cols">
            <template v-if="col === '차수'">
              <b-td :key="`cell${i}${j}`"
                    v-if="i % 3 === 0"
                    rowspan="3"
                    style="background-color: #e9ecef"> {{ getChasu(row[col]) }}
              </b-td>
            </template>
            <template v-else-if="col === '구분'">
              <b-td :key="`cell${i}${j}`"
                    :style="{ 'background-color': getColor(row[col]) }"> {{ row[col] }}
              </b-td>
            </template>
            <template v-else>
              <b-td :key="`cell${i}${j}`" v-if="row['차수'] === 'before'">{{ row[col] }}%</b-td>
              <b-td :key="`cell${i}${j}`" v-else-if="row['차수'] === 'after'">
                {{ row[col] }}% {{ convertToPercentage(row[col] - items[i - 3][col]) }}
              </b-td>
            </template>
          </template>
        </b-tr>
      </template>
    </b-tbody>
  </b-table-simple>
</template>

<script>
export default {
  props: {
    slide: Object,
    items: Array,
    graphType: String
  },
  computed: {
    cols() {
      return Object.keys(this.items[0]);
    },
    showTable() {
      return this.items.length > 0;
    },
  },
  methods: {
    convertToPercentage(number) {
      const percentage = number.toFixed(2);
      if (percentage === '0.00') {
        return '';
      }
      return `(${percentage}%)`;
    },
    getColor(type) {
      let colors = {
        "긍정": '#8faadc',
        "부정": '#ffbf00',
        "중립": '#d6d8db',
      };
      return colors[type];
    },
    getChasu(val){
      if(val != 'after'){
        return '결과'
      }else{
        return '비교 차수 결과'
      }
    },
  }
};
</script>

<style>
#tendency-comparison-table {
    max-height: 400px;
    font-size: 13pt;
    margin-bottom: 0;
    margin-top: 10px;
}

#tendency-comparison-table td,
#tendency-comparison-table th {
    text-align: center;
    vertical-align: middle;
}
</style>
